<template>
  <div id="hres6bu">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchParams"
            :data="index"
            :nowLang="dash.nowLang"
            :unLoadBool="false"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres6buIndex"
            searchBoxAlias="approve"
            :maxRowspan="maxRowspan.index"
            :detailEvent="detailEvent"
            :approveEvent="postHres6buSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :tab2Table="columns[dash.nowLang].detailTab2"
            :toggle="toggle"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6bu/mutation-types'
import detail from 'components/hres6bu/detail'
import moment from 'moment'

export default {
  name: 'hres6bu',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      searchParams: {}
    }
  },
  created () {
    this.receivedHres6buColumnsLabels()
    this.receivedHres6buIndex(this.searchParams)
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6BU_INDEX_DISP,
      detailDisp: types.GET_HRES6BU_DETAIL_DISP,
      maxRowspan: types.GET_HRES6BU_MAX_ROWSPAN,
      columns: types.GET_HRES6BU_COLUMNS,
      labels: types.GET_HRES6BU_LABELS,
      index: types.GET_HRES6BU_INDEX,
      indexSelected: types.GET_HRES6BU_INDEX_SELECTED,
      detail: types.GET_HRES6BU_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq,
        p_dtework: this.indexSelected.dtework
      }
      this.receivedHres6buDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6BU_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6BU_PAGE,
      receivedHres6buColumnsLabels: types.RECEIVED_HRES6BU_COLUMNS_LABELS,
      receivedHres6buIndex: types.RECEIVED_HRES6BU_INDEX,
      receivedHres6buDetail: types.RECEIVED_HRES6BU_DETAIL,
      postHres6buSendApprove: types.POST_HRES6BU_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?57ca21e8